import { minutesToMilliseconds } from "date-fns";

import {
	getCompanyCalendarIntegrationSettings,
	getUserCalendarIntegrationStatus,
	getUserCalendars,
} from "../../services/defs/internal-api";

export const companyCalendarIntegrationSettingsQuery = () => ({
	queryKey: ["company-calendar-integration-settings"],
	queryFn: getCompanyCalendarIntegrationSettings,
	staleTime: minutesToMilliseconds(2),
	meta: {
		errorMessage: "There was an error getting company calendar integration settings.",
	},
});

export const userCalendarIntegrationStatusQuery = () => ({
	queryKey: ["user-calendar-integration-status"],
	queryFn: getUserCalendarIntegrationStatus,
	staleTime: minutesToMilliseconds(1),
	meta: {
		errorMessage: "There was an error getting user calendar integration status.",
	},
});

/**
 * Unified query to get user calendars from any provider
 */
export const userCalendarsQuery = (provider: "google" | "outlook") => ({
	queryKey: ["user-calendars", provider],
	queryFn: () => getUserCalendars({ provider }),
	staleTime: minutesToMilliseconds(5), // 5 minutes
	meta: {
		errorMessage: "Error Fetching Calendars",
	},
});
